import { useState } from 'react'

import * as styled from './TransferConfirmationHeader.styled'
import { TransferDetailsHidden } from './TransferDetailsHidden'
import { TransferDetailsRevealed } from './TransferDetailsRevealed'

type TransferConfirmationHeaderProps = {
  paddingTop: string
  modalMinHeight: number
  isShowingDetails: boolean
  toggleShowDetails: () => void
}

export const TransferConfirmationHeader = ({
  paddingTop,
  modalMinHeight,
  isShowingDetails,
  toggleShowDetails,
}: TransferConfirmationHeaderProps) => {
  const [isAnimationComplete, setIsAnimationComplete] = useState(false)

  return (
    <styled.HeaderWrapper
      $isExpanded={!isShowingDetails}
      $paddingTop={paddingTop}
    >
      {isShowingDetails ? (
        <TransferDetailsRevealed toggleShowDetails={toggleShowDetails} />
      ) : (
        <TransferDetailsHidden
          modalMinHeight={modalMinHeight}
          isAnimationComplete={isAnimationComplete}
          setIsAnimationComplete={setIsAnimationComplete}
          toggleShowDetails={toggleShowDetails}
        />
      )}
    </styled.HeaderWrapper>
  )
}
